import React, {Component} from 'react';
import {Helmet} from 'react-helmet';

import {t} from 'l10n';

import 'sass/headers/header.scss';

class HeaderMemberGuestbook extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <header className="virtualgift">
                <Helmet>
                    <title>{t('My guestbook')}</title>
                </Helmet>
                <div className="content">
                    <h1>{t('My guestbook')}</h1>
                </div>
            </header>
        )
    }
}

export default HeaderMemberGuestbook;


// WEBPACK FOOTER //
// ./src/components/member/HeaderMemberGuestbook.js